export default __webpack_public_path__ + "static/media/pp-girl.5ef01006.webp";